import './App.css';
import Root from "./pages/Root";
import Dashboard from './pages/dashboard/Dashboard';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './App.scss';
import { Provider } from 'react-redux';
import store from './store';
import FileManager from './pages/filemanager/FileManager';
import { createContext, useEffect } from 'react';
import { io } from 'socket.io-client';
import { SERVER_ROUTE } from './utils/commonConstants';
import AuthContextProvider from './context/AuthContextProvider';
import { ConfigProvider, App as AntAppContext } from 'antd';
import Profile from './pages/profile/Profile';
import Tasks from './pages/task/Tasks';
import Staff from './pages/staff/Staff';
import StaffTab from './pages/staff/StaffTab';
import ReportTab from './pages/report/ReportTab';
import ProductsTab from './pages/products/ProductsTab';
import CategoriesTab from './pages/categories/CategoriesTab';
import UsersTab from './pages/users/UsersTab';
import OrdersTab from './pages/orders/OrdersTab';
import SettingsTab from './pages/settings/SettingsTab';
import NotifcationsTab from './pages/notifications/NotificationsTab';
import ReviewTab from './pages/reviews/ReviewTab';
import BlogTab from './pages/blogs/BlogsTab';
import TicketTab from './pages/tickets/TicketsTab';
import Classic from './pages/classic/Classic';
import ClassicDashboard from './pages/classic/children/ClassicDashboard';
import { SYSTEM_SETTINGS } from './utils/configConstants';
import AddOrderView from './pages/classic/children/AddOrderView';
import OrderList from './pages/orders/tabItems/OrderList';
import NotFound from './components/NotFound';

export const SocketContext = createContext(null);

// const socket = io(SERVER_ROUTE);
const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <NotFound />,
        children: [
            {
                path:"/",
                element: <Dashboard />
            },
            {
                path:"/filemanager",
                element: <FileManager />
            },
            {
              path:"/profile",
              element: <Profile />
            },
            {
              path:"/staff",
              element: <Staff />
            },
            {
              path:"/staff/manage",
              element: <StaffTab />
            },
            {
              path:"/tasks",
              element: <Tasks />
            },
            {
              path:"/report",
              element: <ReportTab />
            },
            {
              path:"/products",
              element: <ProductsTab />
            },
            {
              path:"/categories",
              element: <CategoriesTab />
            },
            {
              path:"/users",
              element: <UsersTab />
            },
            {
              path:"/orders",
              element: <OrdersTab />
            },
            {
              path:"/notification",
              element: <NotifcationsTab />
            },
            {
              path:"/reviews",
              element: <ReviewTab />
            },
            {
              path:"/blog",
              element: <BlogTab />
            },
            {
              path:"/ticket",
              element: <TicketTab />
            },
            {
              path:"/reports",
              element: <ReportTab />
            },
            {
              path:"/settings",
              element: <SettingsTab />
            }
        ]
    }
]);

const classicRouter = createBrowserRouter([
  {
    path: "/",
    element: <Classic />,
    errorElement: <NotFound />,
    children: [
      {
          path:"",
          element: <ClassicDashboard />
      },
      {
        path: "order",
        element: <AddOrderView />
      },
      {
        path: "order-history",
        element: <OrderList />
      }
    ]
  }
])

function App() {
  // useEffect(() => {
  //   socket.on("connect", () => {
  //       console.info('socket instance initiated', socket.id);
  //       sessionStorage.setItem('socketId', socket.id)
  //   });

  //   socket.on("disconnect", () => {
  //   });
  // }, [])

  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: '#14b8a6',
            borderRadius: 2,

            // Alias Token
            // colorBgContainer: '#f6ffed',
          }
        }}
        // button={{className: 'btn-default'}}
      >
        <AntAppContext>
          <AuthContextProvider>
              <RouterProvider router={SYSTEM_SETTINGS.isClassicMode ? classicRouter : router} />
          </AuthContextProvider>
        </AntAppContext>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
